import { GiphyFetch } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { Gif } from '@giphy/react-components'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { placeholderCopy } from '../constants'
import { AppContext } from '../context'

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-weight: bold;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
`
const NoResults = () => {
    const [gif, setGif] = useState<IGif>()
    const { apiKey, searchMode } = useContext(AppContext)
    const gf = new GiphyFetch(apiKey)
    const fetchGif = async () => {
        const result = await gf.gif('ViHbdDMcIOeLeblrbq')
        setGif(result.data)
    }
    useEffect(() => {
        if (!gif) fetchGif()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return gif ? (
        <Container>
            <Gif gif={gif} width={50} backgroundColor="rgba(0,0,0,0)" hideAttribution />
            <div>No {placeholderCopy[searchMode]} Found</div>
        </Container>
    ) : null
}
export default NoResults
